module.exports = __webpack_public_path__ + "media/landing_page/dropdown_thin-8a5121c0.png";